import { render, staticRenderFns } from "./SatisMeterSettings.vue?vue&type=template&id=b0230606&scoped=true&"
import script from "./SatisMeterSettings.vue?vue&type=script&lang=js&"
export * from "./SatisMeterSettings.vue?vue&type=script&lang=js&"
import style0 from "./SatisMeterSettings.vue?vue&type=style&index=0&id=b0230606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0230606",
  null
  
)

export default component.exports